module["exports"] = ["Noord", "Oost", "West", "Zuid", "Nieuw", "Oud"];